export const highlightSpelling = (str: string, wordsToFormat: string | string[]) => {
  let wordArray = [].concat(wordsToFormat)
  let newString = str
  wordArray.forEach((word) => {
    const escapedWord = escapeRegExp(word)
    const matched = newString.match(new RegExp(`${escapedWord}[\\w\']*`))
    if (matched && matched[0] &&  matched[0] !== '&nbsp') {
      const augmentedRegex = new RegExp(escapeRegExp(matched[0]), 'g')
      newString = newString.replace(augmentedRegex, `<b>${matched[0]}</b>`)
    }
  })
  return newString
}

// grammar-api reports `character` as a position within the combined
// "<prompt stem> <response>" string, so promptLength and the space joining the
// two come back off to land on the word inside the response on its own.
// promptLength has to be the length of the stem the API was given
// (Prompt#plain_text), not of the stem as the editor renders it.
export const highlightGrammar = (str: string, highlightArray, promptLength: number=0) => {
  if (highlightArray.length < 1) { return str }

  highlightArray.sort(descendingCharacterComparator)

  highlightArray.forEach((highlight) => {
    const offset = Math.max(highlight.character - promptLength - 1, 0)
    let stringAfterOffset = str.slice(offset)
    const stringBeforeOffset = str.slice(0, offset)

    const phraseToFormat = stripEvidenceHtml(highlight.text)
    const escapedPhrase = escapeRegExp(phraseToFormat)
    const matched = stringAfterOffset.match(new RegExp(`${escapedPhrase}[\\w\']*`))

    if (matched && matched[0] &&  matched[0] !== '&nbsp') {
      const augmentedRegex = new RegExp(escapeRegExp(matched[0]))
      stringAfterOffset = stringAfterOffset.replace(augmentedRegex, `<b>${matched[0]}</b>`)
    }

    str = stringBeforeOffset + stringAfterOffset;
  })

  return str
}

export const RICH_TEXT_TAGS_REGEX = /<p>|<\/p>|<u>|<\/u>|<b>|<\/b>|<br>|<br\/>|<em>|<\/em>|<strong>|<\/strong>|<i>|<\/i>/g

export const stripEvidenceHtml = (html: string) => (html || '').replace(RICH_TEXT_TAGS_REGEX, '').replace(/&nbsp;/g, ' ')

// Builds a regex that finds a conjunction at the end of an HTML string,
// capturing any closing tags that follow it (e.g. "</em></strong>") so
// callers can wrap or remove the conjunction without breaking tag nesting.
// Groups: $1 = conjunction word, $2 = trailing closing tags (may be empty)
export const trailingConjunctionPattern = (conjunction: string) =>
  `(${conjunction})((?:\\s*<\\/[^>]+>)*)\\s*$`

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

// Bolding inserts tags into the string, which shifts every position after it,
// so highlights are applied back to front.
const descendingCharacterComparator = (a, b) => b.character - a.character
